import { render, staticRenderFns } from "./AbsencesList.vue?vue&type=template&id=3cc3b627&scoped=true&"
import script from "./AbsencesList.vue?vue&type=script&setup=true&lang=js&"
export * from "./AbsencesList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AbsencesList.vue?vue&type=style&index=0&id=3cc3b627&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc3b627",
  null
  
)

export default component.exports